var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { matchPath } from 'react-router';
import { orderBy, map, flatten, upperFirst } from 'lodash';
import moment from 'moment';
import { ADOBE_PRODUCT_CODE, FeatureFlagNames, PageNamePrefixes, RoutePath, TIME_NA_VALUE, USER_ROLE } from 'constants/app.constant';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { HAD_PATHS } from 'reports/had/constants/had.constant';
import { PS_PATHS } from 'reports/ps/constants';
import { pluralizeUnit } from './ui.helper';
export var getWindowMode = function () {
    var innerWidth = window.innerWidth;
    var mode = { mobile: false, tablet: false, bigTablet: false, desktop: false, wide: false };
    if (innerWidth < 600) {
        return __assign(__assign({}, mode), { mobile: true });
    }
    if (innerWidth >= 600 && innerWidth < 900) {
        return __assign(__assign({}, mode), { tablet: true });
    }
    if (innerWidth >= 900 && innerWidth < 1060) {
        return __assign(__assign({}, mode), { bigTablet: true });
    }
    if (innerWidth >= 1060 && innerWidth < 1200) {
        return __assign(__assign({}, mode), { desktop: true });
    }
    if (innerWidth >= 1200) {
        return __assign(__assign({}, mode), { wide: true });
    }
    return mode;
};
export var getNumberInRange = function (num, min, max) {
    if (max < min) {
        return NaN;
    }
    return Math.max(Math.min(num, max), min);
};
/**
 * Change productName in adobePageData to had in hesi dashboard or scwp in others.
 * @param pathName
 */
export var getAdobeProductCode = function (pathName) {
    var productName = ADOBE_PRODUCT_CODE.SHERPATH_COURSEWARE;
    var hesiPaths = Object.values(HAD_PATHS);
    for (var i = 0; i < hesiPaths.length; i += 1) {
        var matching = matchPath(pathName, {
            path: hesiPaths[i],
            exact: true,
            strict: true
        });
        if (matching) {
            productName = ADOBE_PRODUCT_CODE.HAD_DASHBOARD;
            break;
        }
    }
    return productName;
};
// 1. calculate the total and the percentage of the input array.
// 2. get the decimal of the calculated percentage.
// 3. sort the decimal by descending to get the adding queue (from biggest to smallest decimal).
// 4. round down the calculated percentage.
// 5. get the difference between the round down and the calculated percentage.
// 6. based on the adding queue order index, get the related round down percentage and adding 1.
// 7. repeat the adding to the queue until the difference is zero.
export var roundPercentageTotals = function (numberArr) {
    var total = numberArr.reduce(function (totalNum, currentNum) { return totalNum + currentNum; }, 0);
    var mappedNumberArrayWithObjectIndexDecimal = numberArr.map(function (num, index) { return ({ index: index, value: num, decimalPercentage: ((num / total) * 100) % 1 }); });
    var sortedDecimalInMappedArr = orderBy(mappedNumberArrayWithObjectIndexDecimal, ['decimalPercentage'], ['desc']);
    var percentageResults = numberArr.map(function (num) { return Math.floor((num / total) * 100); });
    var totalPercentage = percentageResults.reduce(function (totalPer, currentPer) { return totalPer + currentPer; }, 0);
    var differentPercent = 100 - totalPercentage;
    if (differentPercent !== 0) {
        for (var i = 0; i < differentPercent; i += 1) {
            var idx = sortedDecimalInMappedArr[i].index;
            percentageResults.splice(idx, 1, percentageResults[idx] + 1);
        }
    }
    return percentageResults;
};
export var checkPathMatchV2 = function (paths, isExact) {
    var _a;
    if (isExact === void 0) { isExact = true; }
    var pathName = (_a = window.location.hash.substring(1).split('#')) === null || _a === void 0 ? void 0 : _a[0];
    return (paths || []).some(function (path) {
        return matchPath(pathName, {
            path: path,
            exact: isExact,
            strict: true
        });
    });
};
export var checkPathMatch = function (paths) {
    return (paths || []).some(function (path) {
        return matchPath(window.location.hash.substring(1), {
            path: path,
            exact: true,
            strict: true
        });
    });
};
export var getAllCwRouteString = function () {
    var allCwRoute = [];
    Object.values(PerformancePath).forEach(function (route) {
        if (typeof route === 'object') {
            allCwRoute = __spreadArray(__spreadArray([], allCwRoute, true), Object.values(route), true);
        }
        else {
            allCwRoute = __spreadArray(__spreadArray([], allCwRoute, true), [route], false);
        }
    });
    return __spreadArray(__spreadArray([], allCwRoute, true), [RoutePath.home], false);
};
export var checkCWLinkDisable = function (isCWBentoBoxLinkShow) {
    return !isCWBentoBoxLinkShow;
};
export var checkEHRLinkDisable = function (eaqTopicMappedHesiExamByCourseId) {
    var _a;
    return (!!eaqTopicMappedHesiExamByCourseId &&
        !!Object.keys(eaqTopicMappedHesiExamByCourseId).length &&
        !!((_a = eaqTopicMappedHesiExamByCourseId[Object.keys(eaqTopicMappedHesiExamByCourseId)[0]]) === null || _a === void 0 ? void 0 : _a.length));
};
export var checkHADLinkDisable = function (hadPrograms) {
    return !(hadPrograms === null || hadPrograms === void 0 ? void 0 : hadPrograms.length);
};
export var checkPRDLinkDisable = function (instructorId) {
    return !instructorId;
};
export var handleNavigationClick = function (isDisabled, onNavigationClick) {
    if (!onNavigationClick || isDisabled) {
        return false;
    }
    return onNavigationClick();
};
export var sherEvolCourseFromEolsUsers = function (eolsUsers) {
    var courseSections = flatten(map(eolsUsers, 'courseSections')) || [];
    return courseSections.filter(function (_a) {
        var _b = _a.entitlements, entitlements = _b === void 0 ? [] : _b;
        return entitlements.length > 0;
    });
};
export var getTimeZone = function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
export var isBreadcrumbBackTitleShown = function (breadcrumbBackTitle) {
    var erp = PageNamePrefixes.erp, ps = PageNamePrefixes.ps;
    if (checkPathMatch([PS_PATHS.homePage]) && breadcrumbBackTitle === ps) {
        return false;
    }
    if (checkPathMatch([RoutePath.reportingPortal]) && breadcrumbBackTitle === erp) {
        return false;
    }
    return true;
};
export var openLinkInNewTab = function (path) {
    window.open("/#".concat(path), '_blank');
};
// A freshly opened tab starts with a single history entry; same-tab app-link navigations (and each
// window.location.assign round-trip hop) add entries, so length > 1 means the launch was same-tab.
export var isLaunchedInNewTab = function () { return window.history.length <= 1; };
export var isStudent = function (eolsUser) {
    return (eolsUser === null || eolsUser === void 0 ? void 0 : eolsUser.role) === USER_ROLE.STUDENT || (eolsUser === null || eolsUser === void 0 ? void 0 : eolsUser.type) === USER_ROLE.STUDENT;
};
export var getStudentUserFullName = function (user) {
    var _a = user || {}, firstName = _a.firstName, lastName = _a.lastName;
    if (!firstName || !lastName) {
        return '';
    }
    return "".concat(upperFirst(lastName), ", ").concat(upperFirst(firstName));
};
export var callFunction = function (func, param) {
    if (func && typeof func === 'function') {
        func(param);
    }
};
export var validURL = function (str) {
    try {
        var normalized = /^https?:\/\//i.test(str) ? str : "https://".concat(str);
        var url = new URL(normalized);
        var hostname = url.hostname;
        // Require a dot with at least 2 characters after it (i.e. a real TLD or IP segment)
        return (url.protocol === 'http:' || url.protocol === 'https:') && /\.[a-z0-9]{2,}$/i.test(hostname);
    }
    catch (_a) {
        return false;
    }
};
export var convertObjectKeyFromSnakeToCamel = function (obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return convertObjectKeyFromSnakeToCamel(item); });
    }
    return Object.keys(obj).reduce(function (camelObj, key) {
        var _a;
        var camelKey = key.replace(/_(\w)/g, function (_, p1) { return p1.toUpperCase(); });
        return __assign(__assign({}, camelObj), (_a = {}, _a[camelKey] = convertObjectKeyFromSnakeToCamel(obj[key]), _a));
    }, {});
};
export var combineCondition = function (condition) {
    var conditions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        conditions[_i - 1] = arguments[_i];
    }
    return conditions.reduce(function (acc, cur) { return acc && cur; }, condition);
};
export var isEnabledMockService = function () {
    return sessionStorage.getItem(FeatureFlagNames.ENABLE_MOCK_SERVICE_WORKER) === 'true';
};
export var sanitizeString = function (str) {
    return str
        .normalize('NFKC') // Normalize the string to a common form
        .replace(/\s+/g, '') // Remove all whitespace characters
        .replace(/\u200B/g, '') // Remove zero-width spaces
        .replace(/[-–—]/g, '-'); // Replace all types of dashes with a hyphen
};
export var formatTimeSpent = function (timeSpentSeconds) {
    var duration = moment.duration(timeSpentSeconds, 'seconds');
    var mins = duration.minutes();
    var seconds = duration.seconds();
    if (mins === 0 && seconds === 0) {
        return TIME_NA_VALUE;
    }
    if (mins === 0) {
        return "".concat(seconds, "s");
    }
    return "".concat(mins).concat(pluralizeUnit(mins, 'min'), " ").concat(seconds, "s");
};
